module.exports = __webpack_public_path__ + "static/media/comment-icon.ce29ce8f.svg";